/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import {fetchSensorData, fetchSensorCount} from "../../../api/homeApi";

function useFetchRelatedSensors(currentPage, pageSize, order_by, order_dir, filter, clId) {

    const [data, setData] = useState({
        sensorList: [],
        sensorCount: 0
    });
    let offset = (currentPage - 1) * pageSize;
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
  
    useEffect(() => {
        if (!clId) {
            console.error('sensorData or corrosionLoop ID is undefined');
            return;
        }
       filter = filter + ` AND sensor.corrosionLoop = '${clId}'`;
       
        const fetchData = async () => {
          setLoading(true);
          try {
          const [sensorResponse, countResponse] = await Promise.all([
            fetchSensorData(filter, pageSize, offset, order_by, order_dir),
            fetchSensorCount(filter),
          ]);
          setData({
                  sensorList: sensorResponse,
                  sensorCount: countResponse,
                });
          } catch (err) {
            toast.error("Cannot fetch Related Sensor List");
            setError(err);
          } finally {
            setLoading(false);
          }
        };
       
          fetchData();
    }, [currentPage, order_by, order_dir, filter, clId]);


    return { data, loading, error };

}



export default useFetchRelatedSensors;